import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-log_activity",
  "use": "icon-log_activity-usage",
  "viewBox": "0 0 12 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 12 13\" id=\"icon-log_activity\">\n    <path fill=\"#2887EB\" d=\"M1 0v3h1V1h6.999L9 4.209l1 .998V12H2v-1.03l-1 .666V13h10V5.207l1-1V0H1zm8.999 1H11v2.793l-.5.5-.5-.499L9.999 1zM0 4v5h1v1.435L3.151 9H6.5V4H0zm1 1h4.5v3H2.849L2 8.565V8H1V5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol